import map from "lodash/fp/map";
import assign from "lodash/fp/assign";

class BusesPageTransform {
  constructor() {
    "ngInject";

    // NOTE: name is used for (user roles)
    this.item = {
      title: "Bus",
      state: "bus",
      name: "bus",
    };

    this.fields = [
      { title: "Type", name: "type" },
      { title: "Company", name: "company" },
      { title: "Captain", name: "captain" },
      { title: "Supplier", name: "supplier" },
      { title: "Plates", name: "plates" },
    ];

    this.filters = [
      {
        name: "captain",
        title: "Captain",
        icon: "person",
        resource: "Captain",
        hasExact: true,
        exactFields: ["name", "phone"],
        size: 25,
      },
      { name: "type", title: "Bustype", icon: "toll", resource: "Bustype" },
      {
        name: "company",
        title: "Company",
        icon: "business",
        resource: "Company",
      },
      {
        name: "search",
        title: "Search",
        icon: "search",
        isSearch: true,
        resource: "Bus",
        state: "bus",
        size: 25,
      },
    ];

    this.addOptions = {
      title: "Add New Bus",
      icon: "add",
      fields: [
        {
          resource: "Bustype",
          name: "type",
          title: "Bustype",
          isResource: true,
          isRequired: true,
        },
        {
          resource: "Company",
          name: "company",
          title: "Company",
          isResource: true,
          isRequired: false,
        },
        {
          resource: "Company",
          name: "supplier",
          title: "supplier",
          isResource: true,
          isRequired: false,
        },
        {
          resource: "Captain",
          name: "captain",
          title: "Captain",
          isResource: true,
          isRequired: false,
          hasExact: true,
          exactFields: ["name", "phone"],
        },
        {
          name: "year",
          title: "Year",
          type: "number",
          isText: true,
          isRequired: true,
        },
        {
          name: "color",
          title: "Color",
          type: "text",
          isText: true,
          isRequired: true,
        },
        {
          name: "plates",
          title: "Plates",
          type: "text",
          isText: true,
          isRequired: true,
        },
      ],
    };
  }

  justify(data) {
    const format = (item) => {
      item = assign({ _id: item._id }, item._source);
      item.name = item.plates;

      return item;
    };

    return map(format)(data);
  }
}

export default BusesPageTransform;



// WEBPACK FOOTER //
// ./src/pages/buses/buses.transforms.js